import axios from 'axios'
import { API_URL } from './settings.js'

const instance = axios.create({
  withCredentials: true,
  baseURL: API_URL
})

export default {
  /**
   * GET request
   * @param {string} url Request URL
   * @param {import('axios').AxiosRequestConfig} [options] Request configuration
   */
  get (url, options) {
    return instance.get(url, options)
  },

  /**
   * POST request
   * @param {string} url Request URL
   * @param {*} data Request data
   */
  post (url, data) {
    return instance.post(url, data)
  },

  /**
   * DELETE request
   * @param {string} url Request URL
   */
  delete (url) {
    return instance.delete(url)
  }
}
